


































import { Subscription, EventJson, Event, Form, FormStep, FormOption } from 'inscreva-sse-models';
import groupBy from 'lodash.groupby';
import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/base/Loading.vue';
import toast from '@/components/toast';
import { ToastType } from '@/components/toast/tost-type.enum';

import EmptyEventMessageComponent from '../components/EmptyEventMessage.vue';
import SubscriptionChartPolarAreaComponent from '../components/SubscriptionChartPolarArea.vue';
import SubscriptionDataTableComponent from '../components/SubscriptionDataTable.vue';
import { sessionStore } from '../store/session';
import { subscriptionStore } from '../store/subscription';

@Component({
  components: {
    Loading,
    EmptyEventMessage: EmptyEventMessageComponent,
    SubscriptionChartPolarArea: SubscriptionChartPolarAreaComponent,
    SubscriptionDataTable: SubscriptionDataTableComponent,
  },
})
export default class StatisticsPage extends Vue {
  private isLoading: boolean = null;

  private subscriptions: Array<Subscription> = [];

  private subscriptionsFiltered: Array<Subscription> = [];

  private optionSelected: FormOption = null;

  async created() {
    await this.fetch();
  }

  async fetch() {
    try {
      this.isLoading = true;
      this.subscriptions = await subscriptionStore.list();
      this.subscriptionsFiltered = this.subscriptions;
    } catch (err) {
      toast('Erro ao carregar dados', ToastType.ERROR);
    }
    this.isLoading = false;
  }

  get event(): Event {
    return EventJson.fromJson(sessionStore.session.event);
  }

  get form(): Form {
    return (this.event.steps.find(({ type }) => type === 'form') as FormStep).form;
  }

  get infos() {
    return this.form.fields
      .filter((field) => this.subscriptions.some((subscription) => !!subscription[field.id]))
      .map((field) => ({
        ...field,
        values: this.subscriptions
          .filter((subscription) => !!subscription[field.id])
          .map((subscription) => ({
            _id: subscription._id,
            value: subscription[field.id],
          })),
      }));
  }

  get options() {
    return this.infos.filter((elm) => elm.options && elm.options.length);
  }

  get options_label() {
    return this.options.flatMap((option) =>
      Object.entries(option.values).map(([keys, values]) => ({ text: (keys as any).text, label: Object.keys(values) })),
    );
  }

  get options_by_option() {
    return groupBy(this.options_label, Object.values);
  }

  chartDataOption(option: FormOption & { values: Array<any> }) {
    const labels = option.options.flatMap(({ label, name, text }) => ({ label: label || name, text }));
    return {
      id: option.id,
      labels: labels.map(({ text }) => text),
      datasets: [
        {
          label: '# of Votes',
          data: labels.flatMap(
            (label) => option.values.filter(({ value }) => Object.keys(value).includes(label.label)).length,
          ),
          backgroundColor: labels.map((i, index, array) => `hsl(204, 50%, ${((index + 1) / array.length) * 100}%)`),
          borderColor: labels.map(() => `hsl(204, 50%, 50%)`),
          borderWidth: 1,
        },
      ],
    };
  }

  get chart_options() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      onClick: this.clickOnChart,
    };
  }

  clickOnChart(chart: any, event: any) {
    // const label = event[0]?._model?.label || '';
    const optionId = event[0]?._chart.config.data.id;
    const optionLabel = event[0]?._model?.label;
    const option = this.options.find(({ id }) => id === optionId);
    this.optionSelected = option;
    this.optionSelected.optionText = optionLabel;
    this.optionSelected.optionValue = option.options.find((val) => val.text === optionLabel).name;
    this.subscriptionsFiltered = this.subscriptions.filter(
      (subscription) =>
        !this.optionSelected ||
        (!!subscription[this.optionSelected.id] &&
          Object.keys(subscription[this.optionSelected.id]).some((name) => this.optionSelected.optionValue === name)),
    );
  }

  eraseSelectedOption() {
    this.optionSelected = null;
    this.subscriptionsFiltered = this.subscriptions;
  }
}
